"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventItemInUse = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var storybook_1 = require("@eyecons/storybook");
var Time = function (_a) {
    var duration = _a.duration, timestamp = _a.timestamp;
    return (react_1.default.createElement("div", { className: 'storybook-producer-eiu-time' },
        react_1.default.createElement("span", { className: 'storybook-producer-eiu-time-timestamp', onClick: function () { return jwplayer().seek(timestamp); } }, storybook_1.Helpers.timeFormatted(timestamp)),
        duration > 0 &&
            react_1.default.createElement("span", { className: 'storybook-producer-eiu-time-duration' },
                duration,
                " sec")));
};
var Info = function (_a) {
    var label = _a.label, team = _a.team;
    return (react_1.default.createElement("div", { className: 'storybook-producer-eiu-info' },
        react_1.default.createElement("span", null, label),
        react_1.default.createElement("span", { className: 'storybook-producer-eiu-team' }, team && team.nameAbbreviated || '-')));
};
var Actions = function (_a) {
    var createClip = _a.createClip, deleteEvent = _a.deleteEvent, hasClip = _a.hasClip, type = _a.type;
    return (react_1.default.createElement("div", { className: 'storybook-producer-eiu-actions' },
        react_1.default.createElement(storybook_1.Buttons.Button, { type: hasClip ? 'secondary' : 'default', disabled: hasClip, icon: hasClip ? 'check' : 'scissors', onClick: createClip, outline: true }, "Clip"),
        !['match', 'clock'].includes(type) &&
            react_1.default.createElement(storybook_1.Buttons.Button, { icon: 'trash', onClick: deleteEvent, outline: true })));
};
var EventItemInUse = function (_a) {
    var clip_id = _a.clip_id, createClip = _a.createClip, deleteEvent = _a.deleteEvent, duration = _a.duration, editEvent = _a.editEvent, event_type = _a.event_type, id = _a.id, label = _a.label, team = _a.team, timestamp = _a.timestamp;
    return (react_1.default.createElement("div", { className: 'storybook-producer-eiu' },
        react_1.default.createElement("div", { className: 'storybook-producer-eiu-teamcolor', style: team ? { backgroundColor: team.colour } : {} }),
        react_1.default.createElement(Time, { duration: duration, timestamp: timestamp }),
        react_1.default.createElement(Info, { label: label, team: team }),
        react_1.default.createElement(Actions, { createClip: function () { return createClip(id, timestamp); }, deleteEvent: function () { return deleteEvent(id); }, editEvent: function () { return editEvent(id); }, hasClip: !!clip_id, type: event_type })));
};
exports.EventItemInUse = EventItemInUse;
exports.EventItemInUse.propTypes = {
    createClip: prop_types_1.default.func,
    deleteEvent: prop_types_1.default.func,
    duration: prop_types_1.default.number,
    editEvent: prop_types_1.default.func,
    id: prop_types_1.default.number,
    label: prop_types_1.default.string,
    team: prop_types_1.default.object,
    timestamp: prop_types_1.default.number,
};
exports.EventItemInUse.defaultProps = {
    createClip: function () {
    },
    deleteEvent: function () {
    },
    duration: 0,
    editEvent: function () {
    },
    id: '',
    label: '',
    team: {},
    timestamp: '',
};
